import * as Yup from "yup";

export const invoiceSchema = Yup.object().shape({

  display_name: Yup.string().required("Display name is required"),
  
  customerType: Yup.string().required("Company type is required"),

  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),

  qb_customer_id: Yup.string(),
  phoneNo: Yup.string().required("Phone number is required"),
  address: Yup.string().required("Address is required"),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  zip: Yup.string()
    .matches(/^\d{5}$/, "Invalid ZIP code")
    .required("ZIP code is required"),
  poNumber: Yup.string(),
  salesRep: Yup.string(),

  salesTax: Yup.number(),

  discounts: Yup.number().min(0, "Discounts must not be negative"),

  option: Yup.string()
    .oneOf(["Amount", "Percent"], "Invalid discount option")
    .test("option-required", "Discount option is required", function (value) {
      const { discounts } = this.parent;
      return discounts > 0 ? !!value : true;
    }),

  notes: Yup.string(),
  invoiceNo: Yup.string().required("Invoice number is required"),
  date: Yup.date().required("Date is required"),
  invoiceStatus: Yup.string().required("Invoice status is required"),

  // id: Yup.string(),
  // isDraft: Yup.boolean(),
  
  billingSameAsShipping: Yup.boolean(),

  shippingAddress: Yup.string().test(
    "shipping-address-required",
    "Shipping address is required",
    function (value) {
      const { billingSameAsShipping } = this.parent;
      return billingSameAsShipping || (value !== undefined && value !== "");
    }
  ),
  shippingCity: Yup.string().test(
    "shipping-city-required",
    "Shipping city is required",
    function (value) {
      const { billingSameAsShipping } = this.parent;
      return billingSameAsShipping || (value !== undefined && value !== "");
    }
  ),
  shippingState: Yup.string().test(
    "shipping-state-required",
    "Shipping state is required",
    function (value) {
      const { billingSameAsShipping } = this.parent;
      return billingSameAsShipping || (value !== undefined && value !== "");
    }
  ),
  shippingZip: Yup.string().test(
    "shipping-zip-required",
    "Shipping ZIP code is required",
    function (value) {
      const { billingSameAsShipping } = this.parent;
      return (
        billingSameAsShipping ||
        (value !== undefined && value !== "" && /^\d{5}$/.test(value))
      );
    }
  ),


});

export const addCustomerSchema = Yup.object().shape({

  DisplayName: Yup.string().required("Display name is required"),
  email: Yup.string().email("Enter a valid email").required("Email is required"),
  address: Yup.string().required("Address is required"),
  city: Yup.string().required("City is required"),

  state: Yup.string().required("State is required"),
  country: Yup.string().required("Country is required"),
  
  phoneNo: Yup.string()
    .required("Phone number is required")
    .matches(/^\(\d{3}\) \d{3}-\d{4}$/, "Enter a valid format: (999) 999-9999"),
  
  zip: Yup.string()
    .required("Zip code is required")
    .matches(/^\d{5,}$/, "Zip code must have at least 5 digits"),
    

    billingSameAsShipping: Yup.boolean(),

    shippingName: Yup.string(), 
    shippingAddress: Yup.string(),
    shippingCity: Yup.string(),
    shippingState: Yup.string(),
    shippingZip: Yup.string(),

  credit_line_balance: Yup.string().required("Credit Line Balance is required"),
  total_credit_line: Yup.string().required("Total Credit Line is required"),
});

